import React from 'react';
import { useConfig } from '../../../../hooks/useConfig';
import ProcessDiagram from './ProcessDiagram';
import ProcessDiagram3D from './ProcessDiagram3D';
import { normalizeScenarioTaskDiagramRenderMode } from './renderMode';
import type { ProcessRuntimeState, TaskPhase } from './types';
import type { ProcessGraphCompileResult } from './utils/processGraph';

interface ProcessDiagramRendererProps {
  processJson: string;
  phase: TaskPhase;
  processStates: Map<string, ProcessRuntimeState>;
  suppressMotion?: boolean;
  onCompiled?: (graph: ProcessGraphCompileResult) => void;
  onDoneViewportSettled?: () => void;
}

const ProcessDiagramRenderer: React.FC<ProcessDiagramRendererProps> = props => {
  const { globalConfig } = useConfig();
  const config = globalConfig as {
    scenarioTaskProcessDiagramRenderMode?: unknown;
  };
  const renderMode = normalizeScenarioTaskDiagramRenderMode(
    config.scenarioTaskProcessDiagramRenderMode
  );

  if (renderMode === '3d') {
    return <ProcessDiagram3D {...props} />;
  }

  return <ProcessDiagram {...props} />;
};

export default ProcessDiagramRenderer;
